import {quoteChange, QuoteChange} from "./change/QuoteChangeComponent";
import {quoteState, QuoteState} from "./state/QuoteStateComponent";
import {currentQuote, CurrentQuote} from "./current/CurrentQuoteComponent";
import {ohlc, OHLC} from "./ohlc/QuoteOhlcComponent";
import {quoteTotals, QuoteTotals} from "./totals/QuoteTotalsComponent";
import {basisOfQuotation, BasisOfQuotation} from "./quotation/BasisOfQuotationComponent";
import {buySellToggleQuote, BuySellToggleQuote} from "./buy-sell-toggle-with-quote/BuySellToggleQuoteComponent";
import {quoteChangeV2, QuoteChangeV2} from "./change-v2/QuoteChangeComponentV2";

export default function() {
    return angular.module("tfApp.quote.components", [])
                  .component(BasisOfQuotation, basisOfQuotation())
                  .component(CurrentQuote, currentQuote())
                  .component(BuySellToggleQuote, buySellToggleQuote())
                  .component(OHLC, ohlc())
                  .component(QuoteChange, quoteChange())
                  .component(QuoteChangeV2, quoteChangeV2())
                  .component(QuoteState, quoteState())
                  .component(QuoteTotals, quoteTotals())
                  .name;
}
